
import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import GetDists from '../Dropdowns/getAllDistricts';
import GetAfsoo from '../Dropdowns/getAfsoAll';
const DeviceDealerDetails = () => {
  const [districtCode, setDistrictCode] = useState('0');
  const [afsoCode, setAfsoCode] = useState('0');
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingAfso, setLoadingAfso] = useState(false);
  const [message, setMessage] = useState('');
  const [loadingExcel, setLoadingExcel] = useState(false);
  const downloadExcel = (data, distCode, afsoCode) => {
    if (data.length === 0) return;
    const distName = distCode === '0' ? 'All Districts' : (data.length > 0 ? data[0].district : 'NA');
    const afsoName = afsoCode === '0' ? 'All AFSO' : (data.length > 0 ? data[0].afso : 'NA');
    let title = `FPS Dealer & Nominee Details`;
    if (distName || afsoName) {
      title += ` - ${distName}/${afsoName}`;
    }
    const heading = `<tr><td colspan="15" style="font-weight:bold; background-color:orange; text-align:center; font-size:16px;">${title}</td></tr>`;
    const headerRow = `<tr bgcolor="#ff9900" style="font-weight:bold; color:black;" align="center">
      <td>Sl No</td>
      <td>District</td>
      <td>AFSO</td>
      <td>FPS Id</td>
      <td>Dealer Name</td>
      <td>Dealer UID</td>
      <td>Dealer Mobile</td>
      <td>Nominee1 Name</td>
      <td>Nominee1 UID</td>
      <td>Nominee1 Mobile</td>
      <td>Nominee2 Name</td>
      <td>Nominee2 UID</td>
      <td>Nominee2 Mobile</td>
      <td>Device No</td>
      <td>Vendor</td>
    </tr>`;
    const bodyRows = data.map((r, i) => `
      <tr>
        <td>${i + 1}</td>
        <td>${r.district || 'NA'}</td>
        <td>${r.afso || 'NA'}</td>
        <td style="mso-number-format:'\\@';">${r.fpsid || 'NA'}</td>
        <td>${r.dealername || 'NA'}</td>
        <td style="mso-number-format:'\\@';">${r.dealer_uid || 'NA'}</td>
        <td>${r.dealer_mobile || 'NA'}</td>
        <td>${r.nominee1_name || 'NA'}</td>
       <td style="mso-number-format:'\\@';">${r.nominee1_uid || 'NA'}</td>
        <td>${r.nominee1_mobile || 'NA'}</td>
        <td>${r.nominee2_name || 'NA'}</td>
<td style="mso-number-format:'\\@';">${r.nominee2_uid || 'NA'}</td>
        <td>${r.nominee2_mobile || 'NA'}</td>
        <td style="mso-number-format:'\\@';">${r.deviceno || 'NA'}</td>
        <td>${r.vendor || 'NA'}</td>
      </tr>`).join('');
    const dateTimeRow = `<tr style="background-color: orange; font-weight: bold;">
      <td colspan="15" align="right">Date Time: ${new Date().toLocaleString()}</td>
    </tr>`;
    const blob = new Blob(
      [`<table border="1">${heading}${headerRow}<tbody>${bodyRows}${dateTimeRow}</tbody></table>`],
      { type: 'application/vnd.ms-excel' }
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${title.replace(/\//g, '-').replace(/ /g, '_')}.xls`;
    a.click();
    URL.revokeObjectURL(url);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    if (!districtCode || !afsoCode) {
      alert('Please select both District and AFSO');
      return;
    }
    try {
      setLoadingExcel(true);
      const res = await fetch(`${process.env.REACT_APP_URL}/api/DeviceDealer/excel-data?distCode=${districtCode}&afsoCode=${afsoCode}`, {
        credentials: 'include'
      });
      if (!res.ok) {
        throw new Error('Network error');
      }
      const data = await res.json();
      if (data.length === 0) {
        setMessage('No data found');
      } else {
        downloadExcel(data, districtCode, afsoCode);
      }
    } catch (err) {
      console.error(err);
      setMessage('Internal exception');
    } finally {
      setLoadingExcel(false);
    }
  };
  const handleDistrictChange = (code) => {
    setDistrictCode(code);
    setMessage('');
    if (code) {
      setAfsoCode('0');
    } else {
      setAfsoCode('');
    }
  };
  const handleAfsoChange = (code) => {
    setAfsoCode(code);
    setMessage('');
  };
  return (
    <form onSubmit={handleSubmit}>
      <table width="35%" align="center" style={{ marginTop: "15px" }}>
        <tbody>
          <tr className="tableheader">
            <td colSpan="4" align="center">Device Dealer Details</td>
          </tr>
          <tr>
            <td>District :</td>
            <td>
              <GetDists
                value={districtCode}
                onChange={handleDistrictChange}
                onLoadingChange={setLoadingDistricts}
              />
            </td>
            <td>Office :</td>
            <td>
              {districtCode === '0' ? (
                <select value="0" disabled>
                  <option value="0">All AFSO</option>
                </select>
              ) : districtCode ? (
                <GetAfsoo
                  dist_code={districtCode}
                  value={afsoCode}
                  onChange={handleAfsoChange}
                  onLoadingChange={setLoadingAfso}
                />
              ) : (
                <select disabled>
                  <option value="">Select</option>
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td colSpan="4" align='center' >
              <button
                type="submit"
                className="button button2"
                disabled={!districtCode || !afsoCode || loadingDistricts || loadingAfso || loadingExcel}
              >
                Download Excel
              </button>
            </td>
          </tr>
        </tbody>
      </table>

       {loadingExcel && (
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <CircularProgress />
        </div>
      )}
      {message && (
        <p className='response' style={{ textAlign: 'center', marginTop: '20px' }}>
          {message}
        </p>
      )}
    </form>
  );
};
export default DeviceDealerDetails;
